/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'unavailable': {
    width: 187,
    height: 178,
    viewBox: '0 0 187 178',
    data: '<defs/><path pid="0" id="unavailable" class="cls-1" d="M2576.01 683.278l-12.02-11.985-19.49 19.435-19.49-19.435-12.02 11.985 19.49 19.436-19.49 19.436 12.02 11.986 19.49-19.436 19.49 19.436 12.02-11.986-19.49-19.436zm44.99-65.326h-25.5V601h-17v50.857h17v-16.952h25.5v127.143h-153V634.905h17v-16.953h-17a16.976 16.976 0 0 0-17 16.953v127.143A16.976 16.976 0 0 0 2468 779h153a16.976 16.976 0 0 0 17-16.952V634.905a16.976 16.976 0 0 0-17-16.953zm-51 0h-59.5V601h-17v50.857h17v-16.952h59.5v-16.953z" transform="translate(-2451 -601)"/>'
  }
})
